<template>
  <div>
    <h5 class="f-s-18 l-h-22 m-b-36 blue-dark">
      Follow STATECS on
    </h5>
        <b-link
          href="https://www.facebook.com/statecsllc"
          target="_blank"
        >
          <i class="i-fb blue" />
        </b-link>
    <!--    <b-link-->
    <!--      href=""-->
    <!--      target="_blank"-->
    <!--    >-->
    <!--      <<i class="i-inst grey" />-->
    <!--    </b-link>-->
    <!--    <b-link-->
    <!--      href=""-->
    <!--      target="_blank"-->
    <!--    >-->
    <!--      <i class="i-tw grey" />-->
    <!--    </b-link>-->
    <b-link
      href="https://www.linkedin.com/company/statecs-llc/"
      target="_blank"
    >
      <i class="i-in cursor-pointer" />
    </b-link>
  </div>
</template>

<script>
export default {
  name: 'FollowStatecsOn',
};
</script>
